import axios from 'axios';
import { getErent2MgmtUrl } from '@utils/env';
import { getTokenHeader } from '@utils/api';

const mgmtApi = () =>
  axios.create({
    baseURL: getErent2MgmtUrl(),
    headers: { 'Content-Type': 'application/json' },
  });

const authHeader = () => ({ 'x-token': getTokenHeader() });

export const listRecords = (params = {}) =>
  mgmtApi()
    .get('/records', { headers: authHeader(), params })
    .then((res) => res.data);

export const getRecord = (id) =>
  mgmtApi()
    .get(`/records/${id}`, { headers: authHeader() })
    .then((res) => res.data);

export const updateRecord = (id, body) =>
  mgmtApi()
    .put(`/records/${id}`, body, { headers: authHeader() })
    .then((res) => res.data);

export const deleteRecord = (id) =>
  mgmtApi()
    .delete(`/records/${id}`, { headers: authHeader() })
    .then((res) => res.data);
